import React from 'react';
import {connect} from 'react-redux';
import queryString from 'query-string';
import SystemRoleEditor from './EditorPages/SystemRoleEditor';
import SystemRoleResults from './ResultsPages/SystemRoleResults';

function SystemRoles({
    urlParams
}) {
    const queryParams = queryString.parse(urlParams);

    return (
        queryParams && queryParams['id'] ?
            <SystemRoleEditor id={queryParams['id']} /> :
            <SystemRoleResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(SystemRoles);